import { Box, Stack, Typography, styled, Skeleton } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useAdminUser } from "@/hooks/use-admin-user";
import { getInitials } from "@/utils/get-initals";
import { formatAccessType } from "@/utils/format-access-type";
import CustomTabs from "@/components/custom/custom-tabs";

const TABS = [
  { label: "Payout", path: "payout" },
  { label: "Settlement", path: "settlement" },
  { label: "Transaction", path: "transaction" },
  { label: "Collection", path: "collection" },
];

const RootWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const HeaderCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2.5),
}));

const OwnerAvatar = styled(Box)(({ theme }) => ({
  width: 56,
  height: 56,
  borderRadius: "50%",
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.1rem",
  fontWeight: 600,
  flexShrink: 0,
}));

const DetailItem = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography fontSize="0.875rem" fontWeight={500}>
      {value || "—"}
    </Typography>
  </Box>
);

const WayaOfficial = () => {
  // const location = useLocation();
  // const navigate = useNavigate();
  const { data: ownerUser, isLoading } = useAdminUser();


  const firstName = ownerUser?.firstName ?? "";
  const lastName = ownerUser?.surname ?? "";
  const email = ownerUser?.email ?? "";
  const phoneNumber = ownerUser?.phoneNumber ?? "";
  //const role = (ownerUser?.roleType ?? [])[1] ?? ownerUser?.accessType ??  "";
  const role = ownerUser?.roleType?.find(r => r.includes("OWNER")) ?? ownerUser?.roleType?.[0] ?? ownerUser?.accessType ?? "";
  const initials = getInitials(firstName, lastName);

  // const activeTab =
  //   TABS.find((t) => location.pathname.startsWith(`/waya-official/${t.path}`))
  //     ?.path ?? false;

  return (
    <RootWrapper>
      {isLoading ? (
      <Skeleton variant="rectangular" height={260} />
        ) : (
      <HeaderCard>
        <OwnerAvatar>{initials || "WA"}</OwnerAvatar>

        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {formatAccessType(firstName)} {formatAccessType(lastName)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            WayaQuick Official — Owner Access
          </Typography>
        </Box>

        <Stack direction="row" spacing={4}>
          <DetailItem label="Email" value={email} />
          <DetailItem label="Phone" value={phoneNumber} />
          <DetailItem label="Role" value={formatAccessType(role)} />
        </Stack>
      </HeaderCard>
      )}

<Box sx={{ backgroundColor: "background.paper", borderRadius: 2, border: "1px solid", borderColor: "divider" }}>
        <Box sx={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "background.paper", px: 1, pt: 1 }}>
          <CustomTabs tabs={TABS} variant="underline" />
        </Box>
        <Box sx={{ p: 2.5 }}>
          <Outlet />
        </Box>
      </Box>
    </RootWrapper>
  );
};

export default WayaOfficial;
